import React from 'react';
import SEO from '../components/SEO';
import PreFooterCallout from '../components/PreFooterCallout';
import { imageUrl, srcSet } from '../lib/images';

export default function Kontakt() {
  return (
    <div>
      <SEO
        title="Kontakt - Advokatfirmaet Kopp"
        description="Kontaktoplysinger Du er altid velkommen til at ringe eller sende en mail, hvis du vil høre mere. (+45) 5162 7235 tk@kopplaw.dk Strandvejen 125, 2900 Hellerup Linkedin-in"
        ogImage={imageUrl('titti-05-til-om-mig-naar-man-er-gaaet-ind-under-fanen.webp')}
      />

      <section className="w-full bg-white py-16 lg:py-24 px-6 lg:px-12">
        <div className="max-w-[1400px] mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-stretch">
          {/* Left Column: Contact details */}
          <div className="lg:col-span-7 space-y-6 flex flex-col justify-between">
            <div className="space-y-6 py-20">
              <h1 className="text-3xl lg:text-4xl font-bold text-[#34657f]">
                Kontaktoplysinger
              </h1>
              <div className="text-xs sm:text-sm text-slate-600 leading-relaxed">
                <p>
                  Du er altid velkommen til at ringe eller sende en mail, hvis du vil høre mere.
                </p>
              </div>

              {/* Direct Details Box */}
              <div className="space-y-4 pt-2">
                <div className="flex items-center space-x-3 text-slate-800">
                  <span className="w-6 h-6 text-[#34657f] flex items-center justify-center shrink-0 text-base">
                    <i className="fa-solid fa-phone" aria-hidden="true" />
                  </span>
                  <div>
                    <a
                      href="tel:004551627235"
                      className="text-xs sm:text-sm font-semibold text-[#34657f] hover:underline whitespace-nowrap"
                    >
                      (+45) 5162 7235
                    </a>
                  </div>
                </div>

                <div className="flex items-center space-x-3 text-slate-800">
                  <span className="w-6 h-6 text-[#34657f] flex items-center justify-center shrink-0 text-base">
                    <i aria-hidden="true" className="fad fa-envelope-open-text" />
                  </span>
                  <div>
                    <a
                      href="mailto:tk@kopplaw.dk"
                      className="text-xs sm:text-sm font-semibold text-[#34657f] hover:underline whitespace-nowrap"
                    >
                      tk@kopplaw.dk
                    </a>
                  </div>
                </div>

                <div className="flex items-center space-x-3 text-slate-800">
                  <span className="w-6 h-6 text-[#34657f] flex items-center justify-center shrink-0 text-base">
                    <i className="fa-solid fa-location-dot" aria-hidden="true" />
                  </span>
                  <div>
                    <span className="text-xs sm:text-sm font-medium text-slate-600">
                      Strandvejen 125, 2900 Hellerup
                    </span>
                  </div>
                </div>

                <div className="flex items-center space-x-3 text-slate-800 pt-1">
                  <span className="w-6 h-6 text-[#34657f] flex items-center justify-center shrink-0 text-base">
                    <i className="fa-brands fa-linkedin text-lg" aria-hidden="true" />
                  </span>
                  <div>
                    <a
                      href="https://www.linkedin.com/in/titti-kopp-31611517/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-xs sm:text-sm font-medium text-[#34657f] hover:underline"
                    >
                      Linkedin-in
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column: Portrait Photo */}
          <div className="lg:col-span-5 relative min-h-[360px] lg:min-h-0 h-full">
            <div className="w-full h-full min-h-[360px] lg:min-h-0 relative lg:absolute lg:inset-0">
              <img
                src={imageUrl('titti-05-til-om-mig-naar-man-er-gaaet-ind-under-fanen.webp', 'width=900,height=600,fit=cover,quality=85,format=auto')}
                srcSet={srcSet('titti-05-til-om-mig-naar-man-er-gaaet-ind-under-fanen.webp')}
                sizes="(max-width: 1024px) 100vw, 40vw"
                alt="Titti Kopp, Advokat, Ph.d."
                className="w-full h-full object-cover object-[50%_12%]"
                style={{ objectPosition: '50% 12%' }}
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Pre-Footer Callout */}
      <PreFooterCallout />
    </div>
  );
}
